module.exports = __webpack_public_path__ + "img/type(7).2c8d681e.png";